import { NgClass, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { CustomDateAdapter } from './date-adapter';
import { CustomDateParserFormatter } from './date-parser-formatter';

@Component({
  selector: 'app-formly-date-selection',
  standalone: true,
  imports: [
    NgIf,
    NgClass,
    FormlyModule,
    ReactiveFormsModule,
    NgbDatepickerModule,
  ],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomDateAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
  ],
  templateUrl: './formly-date-selection.component.html',
  styleUrl: './formly-date-selection.component.scss'
})
export class FormlyDateSelectionComponent extends FieldType<FieldTypeConfig> {

}
